import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Records from "../Component/RecordsEbook.json";
import { Card, Box, CardMedia, Typography, CardContent } from "@mui/material";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}

const SliderBar = () => {
  var settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 5,
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <h3>Top E-Books</h3>
      <Slider {...settings}>
        {Records.map((record) => {
          return (
            <div>
              <a href={record.links}>
                <Card
                  sx={{
                    margin: "0 auto",
                    width: 130,

                    marginBottom: "30px",
                    color: "transparent",
                  }}
                >
                  <CardMedia
                    sx={{ height: 160, width: 130 }}
                    image={record.img}
                    title={record.title}
                  />
                </Card>

                <Typography
                  sx={{ textAlign: "center" }}
                  variant="body2"
                  color="text.secondary"
                >
                  {record.title}
                </Typography>
              </a>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default SliderBar;

// <div>
//   <Box>
//     <a href="https://click.linksynergy.com/link?id=jtjDTYhAZDg&offerid=145238.248089780134291079&bids=145238.248089780134291079&bids=145238.248089780134291079&type=2&murl=https%3a%2f%2fwww.informit.com%2ftitle%2f9780134291079&">
//       <Card
//         sx={{
//           maxWidth: 130,
//           marginLeft: "10px",
//           marginBottom: "30px",
//           color: "transparent",
//         }}
//       >
//         <CardMedia
//           sx={{ border: "0", width: 130, height: 180 }}
//           image="https://www.informit.com/ShowCover.aspx?isbn=9780134291079&amp;type=d"
//           title=""
//         />
//       </Card>
//       <Typography
//         sx={{ textAlign: "left" }}
//         variant="body2"
//         color="text.secondary"
//       >
//         <b>Big Data Fundamentals: Concepts, Drivers & Techniques</b>
//       </Typography>
//     </a>
//   </Box>
// </div>;
